import {
  Components,
  InputInformation,
  ValidationType,
  Size,
  MaskType,
} from '@utahdts/dts-react-common';
import wireInputChanges from './wireInputChanges';

export default ({ inputsOnChange }, isNew, isPrimary, includeEmail = true) => {
  const inputs = {
    name: new InputInformation({
      field: 'name',
      label: 'Name:',
      type: Components.TEXT_INPUT,
      validationTypes: [],
      size: Size.FULL_WIDTH,
    }),
    email: new InputInformation({
      field: 'email',
      label: 'Email',
      type: Components.TEXT_INPUT,
      validationTypes: [ValidationType.IS_EMAIL],
      size: Size.FULL_WIDTH,
      // Email is the immutable business key of a pharmacy-user. It may be set
      // only at creation; editing an existing user shows it read-only. A wrong
      // email is corrected by deleting the user and recreating it.
      disabled: !isNew,
    }),
    phone: new InputInformation({
      field: 'phone',
      label: 'Phone:',
      type: Components.TEXT_INPUT,
      validationTypes: [],
      size: Size.FULL_WIDTH,
      maskType: MaskType.PHONE,
    }),
  };

  // Email is an Administrator-only field; Org Administrators see only the
  // user's name and phone.
  if (!includeEmail) {
    delete inputs.email;
  }

  Object.values(inputs).forEach((input) => {
    isPrimary && input.validationTypes.push(ValidationType.REQUIRED);
  });
  wireInputChanges(inputs, inputsOnChange);

  return inputs;
};
